import React from "react";
import { Row, Col } from 'antd';
// import { Widget } from "../Global/Atomics/Widget";
import Theme from '../../styles/Theme/Theme';
import styled from "styled-components";
import ReactPlayer from "react-player";
import { WidgetCard } from "../Global/Atomics/WidgetCard";
import { StreetBarChartWidget } from "./StreetBarChartWidget";
import { useState } from "react";
import { useEffect } from "react";

const OverlayStyles = styled.div`
    padding-top: 5px;
    padding-right: 5px;
  .overlay-widget{
    box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.15);
    border-radius: ${Theme.radius['lg']};
  }
`;

const trafficData = {
    icon: 'Car',
    title: 'Top 5 Streets with Traffic',
    data: [
        {
            name: 'Rua São Jose',
            value: 20
        },
        {
            name: 'Av. Marginal',
            value: 12
        },
        {
            name: 'Rua do Golfo',
            value: 11
        },
        {
            name: 'Rua Jaime Thompson',
            value: 6
        },
        {
            name: 'Av. Eng. Adelino Amaro da Costa',
            value: 3
        },
        
    ]
};

const parkingData = {
    icon: 'Car',
    title: 'Off-Street Parking Availability',
    data: [
        {
            name: 'Carcavelos',
            value: 123
        },
        {
            name: 'Marechal Carmona',
            value: 105
        },
        {
            name: 'Hipódromo',
            value: 64
        },
        {
            name: 'Tribunal',
            value: 34
        },
        {
            name: 'Cascais Center',
            value: 32
        },
        
    ]
};

export const WidgetsOverlay = () => {
    const [actualVideoIndex, setActualVideoIndex ] = useState(1);
    const [actualVideo, setActualVideo ] = useState('https://www.youtube.com/watch?v=1H0iTzv2jiQ');

    const [ actualNameBarChartIndex, setActualNameBarChartIndex ] = useState(0);
    const [ actualNameBarChartData, setNameBarChartData ] = useState(trafficData);
    
    useEffect(() => {
        const interval = setInterval(() => {
            if(actualVideoIndex === 0){
                setActualVideo('https://www.youtube.com/watch?v=1H0iTzv2jiQ');
                //setActualVideo('https://www.youtube.com/watch?v=O2bCoZSQTuo');
                setActualVideoIndex(1);
            } else if(actualVideoIndex === 1){
                setActualVideo('https://www.youtube.com/watch?v=1H0iTzv2jiQ');
                //setActualVideo('https://www.youtube.com/watch?v=mwN6l3O1MNI');
                setActualVideoIndex(2);
            } else if(actualVideoIndex === 2){
                setActualVideo('https://www.youtube.com/watch?v=1H0iTzv2jiQ');
                //setActualVideo('https://www.youtube.com/watch?v=mwN6l3O1MNI');
                setActualVideoIndex(3);
            } else if(actualVideoIndex === 3){
                setActualVideo('https://www.youtube.com/watch?v=1H0iTzv2jiQ');
                //setActualVideo('https://www.youtube.com/watch?v=ByED80IKdIU');
                setActualVideoIndex(0);
            }
            //Mais exemplos
            //https://www.youtube.com/watch?v=ByED80IKdIU
        }, 60000);//1 em 1 minuto
  
        return () => clearInterval(interval); 
    }, [actualVideoIndex]);

    useEffect(() => {
        const interval = setInterval(() => {
            if(actualNameBarChartIndex === 0){
                setNameBarChartData(parkingData); 
                setActualNameBarChartIndex(1);
            } else if(actualNameBarChartIndex === 1){
                setNameBarChartData(trafficData); 
                setActualNameBarChartIndex(0);
            }
        }, 180000);//3 em 3 minutos
  
        return () => clearInterval(interval); 
    }, [actualNameBarChartIndex]);



    return (
        <OverlayStyles>
            <Row>
                <Col span={6} offset={18}>
                    <div className='player-wrapper'>
                        <ReactPlayer
                            url={actualVideo}
                            className='react-player'
                            loop={true}
                            muted={true}
                            playing={true}
                            controls={false}
                            width='100%'
                            height='100%'
                        />
                    </div>
                    <WidgetCard height='250px'>
                        <StreetBarChartWidget block={actualNameBarChartData}/>
                    </WidgetCard>
                </Col>
            </Row>
        </OverlayStyles>

    );
};
